const layout = {
    state: {
        show_left_block: true,
        show_right_block: true
    },

    getters: {

    },

    mutations: {
        toggle_left_block (state, payload) {
            state.show_left_block = payload;
        },
        toggle_right_block (state, payload) {
            state.show_right_block = payload;
        }
    },

    actions: {

    }
}

export default layout;